import "./Button.css";
const Button = ({ children, onClick }) => (
  <button type="submit" className="button" onClick={onClick}>
    {children}
  </button>
);
export default Button;
